function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-collapse';
import VisibilitySensor from 'react-visibility-sensor';
import { WifiIcon, InfoIconSmall, ChevronDownIconSmall, ChevronUpIconSmall } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
import Modal from './modal';
var NBNLogo = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/powered-by-nbn_a29dedca.png";
import * as styles from './nbn-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NbnCard = _ref => {
  var abbreviation = _ref.abbreviation,
    brand = _ref.brand,
    brandName = _ref.brandName,
    description = _ref.description;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisclaimerOpened = _useState2[0],
    setIsDisclaimerOpened = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isModalOpened = _useState4[0],
    setIsModalOpened = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    visibilityEventSent = _useState6[0],
    setVisibilityEventSent = _useState6[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var toggleDisclaimer = () => {
    setIsDisclaimerOpened(!isDisclaimerOpened);
  };
  return ___EmotionJSX(VisibilitySensor, {
    onChange: isVisible => {
      if (isVisible && !visibilityEventSent) {
        sendEvent('nbn-card-view');
        setVisibilityEventSent(true);
      }
    }
  }, ___EmotionJSX("div", {
    css: styles.nbnCard
  }, ___EmotionJSX("div", {
    css: styles.card
  }, ___EmotionJSX("div", {
    css: styles.top
  }, ___EmotionJSX("div", {
    css: styles.icon
  }, ___EmotionJSX(WifiIcon, null)), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "nbn\xAE ", description, " (", abbreviation, ") is available in this property"), brandName && ___EmotionJSX("div", null, ___EmotionJSX("span", {
    css: styles.subheading
  }, "Max wholesale speed tier available:"), brandName.indexOf('nbn®') > -1 && ___EmotionJSX("span", {
    css: styles.subheadingBold
  }, " nbn\xAE "), ___EmotionJSX("span", {
    css: styles.subheading
  }, brandName.replace('nbn® ', ''))))), ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX("div", {
    css: styles.bottom
  }, ___EmotionJSX("button", {
    type: "button",
    css: styles.link,
    onClick: () => {
      setIsModalOpened(true);
      sendEvent('nbn-info-click');
    }
  }, ___EmotionJSX(InfoIconSmall, null), ___EmotionJSX("p", null, "What does this mean?")), ___EmotionJSX("img", {
    src: NBNLogo,
    alt: ""
  }))), ___EmotionJSX("button", {
    type: "button",
    css: styles.disclaimer,
    onClick: () => {
      toggleDisclaimer();
      sendEvent('nbn-disclaimer-click');
    }
  }, ___EmotionJSX("p", null, "Disclaimer"), isDisclaimerOpened ? ___EmotionJSX(ChevronUpIconSmall, null) : ___EmotionJSX(ChevronDownIconSmall, null)), ___EmotionJSX(Collapse, {
    isOpened: isDisclaimerOpened
  }, ___EmotionJSX("span", {
    css: styles.subheading
  }, "In displaying this information, Allhomes relies on information supplied by"), ___EmotionJSX("span", {
    css: styles.subheadingBold
  }, " nbn"), ___EmotionJSX("span", {
    css: styles.subheading
  }, ". Connection data presented may change from time to time, may not be accurate, complete, up to date, and may not have been validated for accuracy, completeness or reliability.")), ___EmotionJSX(Modal, {
    show: isModalOpened,
    onClose: () => setIsModalOpened(false),
    brand: brand,
    brandName: brandName
  })));
};
NbnCard.propTypes = {
  abbreviation: PropTypes.string,
  brand: PropTypes.string,
  brandName: PropTypes.string,
  description: PropTypes.string
};
NbnCard.defaultProps = {
  abbreviation: '',
  brand: null,
  brandName: null,
  description: ''
};
export default NbnCard;